/* eslint-disable import/no-anonymous-default-export */
import API from "../../util/api";

export default {
  getAPI() {
    return API;
  },
  uploadTask(payload) {
    return API.post(`/admin/task/uploadExcel`, payload);
  },

  getMarketChartInfo() {
    return API.get(`/admin/mi/chartType`);
  },

  getVoucherFile(payload) {
    return API.get(`/test/dataVoucher/companyChart`, { params: payload });
  },

  getTaskDepartmentList(param) {
    return API.get("/admin/task/pdf/department", { params: param });
  },

  getResearchCategory() {
    return API.get(`/admin/research/category`);
  },

  addResearchCategory(payload) {
    return API.post(`/admin/research/category`, payload);
  },

  updateResearchCategory(category_idx, payload) {
    return API.patch(`/admin/research/category/${category_idx}`, payload);
  },

  deleteResearchCategory(category_idx) {
    return API.delete(`/admin/research/category/${category_idx}`);
  },

  updateResearchCategoryOrder(payload) {
    return API.patch(`/admin/research/category/order`, payload);
  },

  checkAuth(headers) {
    return API.get(`/member/admin_check`, headers);
  },
  getInvestorFileList(investor_idx) {
    return API.get(`/manager/company/investor/${investor_idx}/introduce`);
  },
  getRequestInvestmentList(payload) {
    return API.get("/admin/investment", { params: payload });
  },
  getFreeUsList() {
    return API.get(`/admin/ur`);
  },
  getFreeUsInfo(ur_idx) {
    return API.get(`/admin/ur/${ur_idx}`);
  },
  updateFreeUs(ur_idx, payload) {
    return API.patch(`/admin/ur/${ur_idx}`, payload);
  },
  getRequestInvestmentView(investment_idx) {
    return API.get(`/admin/investment/${investment_idx}`);
  },
  RequestInvestmentConfirm(investment_idx, payload) {
    return API.patch(`/admin/investment/${investment_idx}`, payload);
  },
  getIntroduceFileList(investment_idx) {
    return API.get(`/admin/investment/${investment_idx}/file/introduce`);
  },
  getCoreFileList(investment_idx) {
    return API.get(`/admin/investment/${investment_idx}/file/core`);
  },
  getBusinessFileList(investment_idx) {
    return API.get(`/admin/investment/${investment_idx}/file/business`);
  },
  downloadInvestorFile(investor_idx, introduce_idx) {
    window.$Global.download(
      `/manager/company/investor/${investor_idx}/introduce/${introduce_idx}/download`
    );
  },
  downloadIntroduceFile(investment_idx, introduce_idx) {
    window.$Global.download(
      `/admin/investment/${investment_idx}/file/introduce/${introduce_idx}/download`
    );
  },
  downloadCoreFile(investment_idx, core_idx) {
    window.$Global.download(
      `/admin/investment/${investment_idx}/file/core/${core_idx}/download`
    );
  },
  downloadBusinessFile(investment_idx, business_idx) {
    window.$Global.download(
      `/admin/investment/${investment_idx}/file/business/${business_idx}/download`
    );
  },
  downloadSignup() {
    window.$Global.download(`/admin/company/excel_download`);
  },

  downloadMarket() {
    return API.get(`/admin/mi/request/excel`, {
      responseType: "arraybuffer",
    }).then((res) => window.$Global.dataDownload(res));
  },

  downloadJoDal() {
    window.$Global.download(`/admin/task/download_findbiz_excel`);
  },

  addNews(payload) {
    return API.post(`/admin/news`, payload);
  },
  getNewsInfo(news_idx) {
    return API.get(`/admin/news/${news_idx}`);
  },
  updateNews(news_idx, payload) {
    return API.patch(`/admin/news/${news_idx}`, payload);
  },
  deleteNews(news_idx) {
    return API.delete(`/admin/news/${news_idx}`);
  },
  addYoutube(payload) {
    return API.post(`/admin/youtube`, payload);
  },
  getYoutubeInfo(youtube_idx) {
    return API.get(`/admin/youtube/${youtube_idx}`);
  },
  updateYoutube(youtube_idx, payload) {
    return API.patch(`/admin/youtube/${youtube_idx}`, payload);
  },
  deleteYoutube(news_idx) {
    return API.delete(`/admin/youtube/${news_idx}`);
  },
  getSignInfoList(payload) {
    return API.get(`/admin/company`, { params: payload });
  },
  addNotify(payload) {
    return API.post(`/admin/notice`, payload);
  },
  addTutorial(payload) {
    return API.post(`/admin/tutorial`, payload);
  },
  updateNotify(notice_idx, payload) {
    return API.patch(`/admin/notice/${notice_idx}`, payload);
  },
  addQna(payload) {
    return API.post(`/admin/qna`, payload);
  },
  updateQna(notice_idx, payload) {
    return API.patch(`/admin/qna/${notice_idx}`, payload);
  },
  uploadNotifyFile(notice_idx, payload) {
    return API.post(`/admin/notice/${notice_idx}/file`, payload);
  },
  deleteNotify(notice_idx) {
    return API.delete(`/admin/notice/${notice_idx}`);
  },
  getNotifyFileList(notice_idx) {
    return API.get(`/admin/notice/${notice_idx}/file`);
  },
  deleteNotifyFile(notice_idx, file_idx) {
    return API.delete(`/admin/notice/${notice_idx}/file/${file_idx}`);
  },
  uploadQnaFile(qna_idx, payload) {
    return API.post(`/admin/qna/${qna_idx}/file`, payload);
  },
  deleteQna(qna_idx) {
    return API.delete(`/admin/qna/${qna_idx}`);
  },
  getQnaFileList(qna_idx) {
    return API.get(`/admin/qna/${qna_idx}/file`);
  },
  deleteQnaFile(qna_idx, file_idx) {
    return API.delete(`/admin/qna/${qna_idx}/file/${file_idx}`);
  },
  addEdu(payload) {
    return API.post(`/admin/edu`, payload);
  },
  updateTutorial(tutorial_idx, payload) {
    return API.patch(`/admin//tutorial/${tutorial_idx}`, payload);
  },
  updateEdu(edu_idx, payload) {
    return API.patch(`/admin/edu/${edu_idx}`, payload);
  },
  uploadEduFile(edu_idx, payload) {
    return API.post(`/admin/edu/${edu_idx}/file`, payload);
  },
  deleteEdu(edu_idx) {
    return API.delete(`/admin/edu/${edu_idx}`);
  },
  deletetutorial(tutorial_idx) {
    return API.delete(`/admin//tutorial/${tutorial_idx}`);
  },
  getTutorialFileList(tutorial_idx) {
    return API.get(`/admin//tutorial/${tutorial_idx}/file`);
  },
  deleteTutorialFile(tutorial_idx, file_idx) {
    return API.delete(`/admin/tutorial/${tutorial_idx}/file/${file_idx}`);
  },
  uploadImage(payload) {
    return API.post(`/admin/upload/media`, payload);
  },
  uploadImageTrim(payload) {
    return API.post(`/admin/upload/media/trim`, payload);
  },
  stopMember(company_idx) {
    return API.delete(`/admin/company/${company_idx}`);
  },
  deleteMember(company_idx) {
    return API.delete(`/admin/company/${company_idx}/force`);
  },
  recoverMember(company_idx) {
    return API.patch(`/admin/company/${company_idx}/recover`);
  },
  downloadFreeUsFile(ur_idx, file_idx) {
    window.$Global.download(`/admin/ur/${ur_idx}/file/${file_idx}/download`);
  },
  getTaskField() {
    return API.get("/admin/task/field");
  },
  getTaskList(payload, data) {
    return API.post("/admin/task/select", data, { params: payload });
  },
  getTaskInfo(idx) {
    return API.get(`/admin/task/${idx}`);
  },
  addTask(payload) {
    return API.post("/admin/task", payload);
  },
  updateTask(idx, payload) {
    return API.patch(`/admin/task/${idx}`, payload);
  },
  updateTaskAdditional(idx, payload) {
    return API.patch(`/admin/task/${idx}/additional`, payload);
  },
  deleteTask(idx) {
    return API.delete(`/admin/task/${idx}`);
  },

  deleteTaskFile(task_idx, file_idx) {
    return API.delete(`/admin/task/${task_idx}/file/${file_idx}`);
  },

  // 연차료 납부 상태 리스트
  getAnnualPayManageList(payload) {
    return API.get(`/admin/ops/patent_fix/annualPayList`, {
      params: payload,
    });
  },

  // 연차료 납부기한 점검 (조회 전용, nation 선택 가능)
  getAnnualPayDeadlineCheck(payload) {
    return API.get(`/admin/ops/patent_fix/annualPayDeadlineCheck`, {
      params: payload,
    });
  },

  // 연차료 납부 상태 업데이트 (target_idx: patent_idx, payment_state 0이면 application_date null)
  updatePaymentState(payload) {
    return API.patch(`/admin/ops/patent_fix/updatePaymentState`, payload);
  },

  getCommunityCategory() {
    return API.get("/admin/notice/category");
  },

  getCommunityInfo(notice_idx) {
    return API.get(`/admin/notice/${notice_idx}`);
  },

  getCommunityList(payload) {
    return API.get("/admin/notice", { params: payload });
  },

  getCommunityPin(notice_idx) {
    return API.post(`/admin/notice/${notice_idx}/pin`);
  },

  downloadCompanyListExcel(payload) {
    return API.post(`/admin/company/download_annual_pay_info`, payload, {
      responseType: "arraybuffer",
    });
  },

  downloadMailImage(payload) {
    return API.post("admin/mailing/invite", payload, {
      responseType: "arraybuffer",
    });
  },

  getMailing(company_code) {
    return API.post(`/admin/mailing/invite`, { company_code: company_code });
  },

  getMailingUser(company_code) {
    return API.post(`/common/dummy/company/statistic`, {
      company_code: company_code,
    });
  },

  getDailyStatistic(params) {
    return API.get(`/admin/log/visit/daily_statistic`, { params: params });
  },

  postAnnualPay(payload) {
    return API.post(`/admin/dummy/company/annual_pay`, payload);
  },

  getAdminMngCompanyAnnual(params) {
    return API.get(`/admin/company/annualMngPay`, { params: params });
  },

  getAnnulPay(params) {
    return API.get("/admin/dummy/company/annual_pay", { params: params });
  },

  deleteAnnualPay(ap_idx) {
    return API.delete(`/admin/dummy/company/annual_pay/${ap_idx}`);
  },

  getMarketCategory() {
    return API.get("/admin/mi/category");
  },

  addMarketCategory(payload) {
    return API.post("/admin/mi/category", payload);
  },

  updateMarketCategory(category_idx, payload) {
    return API.patch(`/admin/mi/category/${category_idx}`, payload);
  },

  updateMarketCategoryOrder(payload) {
    return API.patch(`/admin/mi/category/order`, payload);
  },

  deleteMarketCategory(category_idx) {
    return API.delete(`/admin/mi/category/${category_idx}`);
  },

  addMarketInfo(payload) {
    return API.post("/admin/mi", payload);
  },

  updateMarketInfo(mi_idx, payload) {
    return API.patch(`/admin/mi/${mi_idx}`, payload);
  },

  getMarketInfo(mi_idx) {
    return API.get(`/admin/mi/${mi_idx}`);
  },

  getMarketList(params) {
    return API.get("/admin/mi", { params: params });
  },

  deleteMarket(mi_idx) {
    return API.delete(`/admin/mi/${mi_idx}`);
  },

  toggleTaskRecommend(task_idx) {
    return API.patch(`/admin/task/${task_idx}/recommanded`);
  },

  addTaskPDF(payload) {
    return API.post("/admin/task/pdf", payload);
  },

  getTaskPDFList() {
    return API.get("/admin/task/pdf");
  },

  updateTaskPDF(pdf_idx, payload) {
    return API.patch(`/admin/task/pdf/${pdf_idx}`, payload);
  },

  deleteTaskPDF(pdf_idx) {
    return API.delete(`/admin/task/pdf/${pdf_idx}`);
  },

  getResearchList(param) {
    return API.get(`/admin/research`, { params: param });
  },

  addResearch(payload) {
    return API.post("/admin/research", payload);
  },

  deleteResearch(research_idx) {
    return API.delete(`/admin/research/${research_idx}`);
  },

  getAlbaList() {
    return API.get("/admin/alba/list");
  },

  getDummyAccount(headers) {
    return API.get("/admin/member/dummy", headers);
  },

  addDummyAccount(payload, headers) {
    return API.post("/admin/member/dummy", payload, headers);
  },

  updateDummyAccount(idx, payload, headers) {
    return API.patch(`/admin/member/dummy/${idx}`, payload, headers);
  },

  deleteDummyAccount(idx, headers) {
    return API.delete(`/admin/member/dummy/${idx}`, headers);
  },

  getAdminCompanyAnnual() {
    return API.get(`/admin/company/annualPay`);
  },

  getAdminCompanyPatentList(company_idx, payload) {
    return API.get(`/admin/company/${company_idx}/patent/annualPay`, {
      params: payload,
    });
  },

  // 소멸 연차료 관리 전용 (dummy_patent 최신 상태 반영)
  getAdminCompanyExpiredPatentList(company_idx, payload) {
    return API.get(`/admin/company/${company_idx}/patent/annualPay/expired`, {
      params: payload,
    });
  },

  // 키프리스 소멸권리정보 조회
  getKiprisStopRightInfo(company_idx, applicationNumber) {
    return API.get(
      `/admin/company/${company_idx}/patent/annualPay/kipris-stop-right/${applicationNumber}`
    );
  },

  // 소멸 연차료 일괄 삭제
  batchDeleteExpiredAnnual(company_idx, payload) {
    return API.post(
      `/admin/company/${company_idx}/patent/annualPay/expired-batch-delete`,
      payload
    );
  },

  getTest(company_idx, payload) {
    return API.post(
      `/admin/company/${company_idx}/patent/annualPay/test`,
      payload
    );
  },

  getAdminCompanyTradeMarkList(company_idx, payload) {
    return API.get(`/admin/company/${company_idx}/trademark/annualPay`, {
      params: payload,
    });
  },

  getAdminCompanyDesignList(company_idx, payload) {
    return API.get(`/admin/company/${company_idx}/design/annualPay`, {
      params: payload,
    });
  },

  getAdminPatentAnnualPay(company_idx, annual_pay_idx) {
    return API.get(
      `/admin/company/${company_idx}/patent/annualPay/${annual_pay_idx}`,
      // 팝업 내부 로딩과 전역 스피너 중복 방지
      { skipGlobalLoading: true }
    );
  },

  updateAdminPaymentCompleted(company_idx, annual_pay_idx, type) {
    return API.patch(
      `/admin/company/${company_idx}/${type}/annualPay/${annual_pay_idx}/paymentCompleted`
    );
  },

  updateAdminPaymentAllCompleted(payload) {
    return API.patch(
      `/admin/company/patent/annualPay/AllPaymentCompleted`,
      payload
    );
  },

  getAdminTradeMarkAnnualPay(company_idx, annual_pay_idx) {
    return API.get(
      `/admin/company/${company_idx}/trademark/annualPay/${annual_pay_idx}`,
      { skipGlobalLoading: true }
    );
  },

  getAdminDesignAnnualPay(company_idx, annual_pay_idx) {
    return API.get(
      `/admin/company/${company_idx}/design/annualPay/${annual_pay_idx}`,
      { skipGlobalLoading: true }
    );
  },

  getAdminPatentReceiptData(company_idx, annual_pay_idx) {
    return API.get(
      `/admin/company/${company_idx}/patent/annualPay/${annual_pay_idx}/billing`
    );
  },

  getAdminTradeMarkReceiptData(company_idx, annual_pay_idx) {
    return API.get(
      `/admin/company/${company_idx}/trademark/annualPay/${annual_pay_idx}/billing`
    );
  },

  getAdminDesignReceiptData(company_idx, annual_pay_idx) {
    return API.get(
      `/admin/company/${company_idx}/design/annualPay/${annual_pay_idx}/billing`
    );
  },

  uploadAdminPatentReceiptData(company_idx, annual_pay_idx, data) {
    return API.post(
      `/admin/company/${company_idx}/patent/annualPay/${annual_pay_idx}/billing`,
      data,
      { skipGlobalLoading: true }
    );
  },

  uploadAdminTradeMarkReceiptData(company_idx, annual_pay_idx, data) {
    return API.post(
      `/admin/company/${company_idx}/trademark/annualPay/${annual_pay_idx}/billing`,
      data,
      { skipGlobalLoading: true }
    );
  },

  uploadAdminDesignReceiptData(company_idx, annual_pay_idx, data) {
    return API.post(
      `/admin/company/${company_idx}/design/annualPay/${annual_pay_idx}/billing`,
      data,
      { skipGlobalLoading: true }
    );
  },

  uploadAdminBatchBilling(company_idx, asset_type, formData) {
    return API.post(
      `/admin/company/${company_idx}/${asset_type}/annualPay/billing/batch`,
      formData,
      { skipGlobalLoading: true }
    );
  },

  getAdminBatchBillingPreview(company_idx, asset_type, annual_pay_idxs) {
    return API.post(
      `/admin/company/${company_idx}/${asset_type}/annualPay/billing/batch-preview`,
      { annual_pay_idxs },
      { skipGlobalLoading: true }
    );
  },

  deleteAdminPatentReceiptFile(company_idx, annual_pay_idx, file_idx) {
    return API.delete(`/admin/company/${company_idx}/patent/annualPay/${annual_pay_idx}
/billing/file/${file_idx}`);
  },

  deleteAdminTradeMarkReceiptFile(company_idx, annual_pay_idx, file_idx) {
    return API.delete(`/admin/company/${company_idx}/trademark/annualPay/${annual_pay_idx}
/billing/file/${file_idx}`);
  },

  downloadPatentFile(company_idx, annual_pay_idx, file_idx) {
    return API.post(`/admin/company/${company_idx}/patent/
annualPay/${annual_pay_idx}/file/${file_idx}/download`);
  },

  downloadTradeMarkFile(company_idx, annual_pay_idx, file_idx) {
    return API.post(`/admin/company/${company_idx}/trademark/
annualPay/${annual_pay_idx}/file/${file_idx}/download`);
  },
  // 고객사 회사 정보
  getAdminCompanyInfo(company_idx) {
    return API.get(`/admin/company/${company_idx}`);
  },
  getAdminCompanyPatentYearList(company_idx, payload) {
    return API.get(
      `/admin/company/${company_idx}/patent/annualPay/annual_pay_year`,
      { params: payload }
    );
  },
  getAdminCompanyInventorAllList(company_idx, payload) {
    return API.get(`/admin/inventor/`, { params: payload });
  },

  getInventorInfo(idx) {
    return API.get(`/admin/inventor/${idx}`);
  },

  updateInventorInfo(idx, payload) {
    return API.patch(`/admin/inventor/${idx}`, payload);
  },

  getAdminCompanyGiveUpList(payload) {
    return API.get(`/admin/inventor/giveUp`, { params: payload });
  },

  getAdminInventorList(payload) {
    return API.get(`/admin/inventor/inventorUserList`, { params: payload });
  },

  getPatentInventorList(params) {
    return API.get("/admin/inventor/patentInventorList", { params: params });
  },

  getInventorPatentList(params) {
    return API.get(`/admin/inventor/patent/list/`, { params: params });
  },
  // 연차료 비교 다른값 Post
  annualPayDiff(company_idx, payload) {
    return API.post(
      `/admin/company/${company_idx}/patent/annualPay/annual_pay_diff`,
      payload
    );
  },
  // 연차료 엑셀다운
  annualPayexcel(company_idx, payload) {
    window.$Global.download_get(
      `/admin/company/${company_idx}/patent/annualPay/annual_pay_excel`,
      { params: payload }
    );
  },

  isPaid(payload) {
    return API.get(`/common/inventor/inventor_isPaid`, {
      params: { aesq: payload.aesp },
    });
  },

  isGiveup(payload) {
    return API.get(`/common/inventor/inventor_isGiveup`, {
      params: { aesq: payload.aesp },
    });
  },

  check_birthday(payload) {
    return API.post(`/common/inventor/inventor_check_birthday`, payload);
  },

  confirm_IsPaid(payload) {
    return API.post(`/common/inventor/confirm_IsPaid`, payload);
  },

  confirm_IsGiveup(payload) {
    return API.post(`/common/inventor/confirm_IsGiveup`, payload);
  },

  confirm_IsRecipt(payload) {
    return API.post(`/common/inventor/isrecept`, payload);
  },

  annualPayComment(company_idx, payload) {
    return API.post(
      `/admin/company/${company_idx}/patent/annualPay/annual_pay_comment`,
      payload
    );
  },

  annualPayFinalComment(company_idx, payload) {
    return API.post(
      `/admin/company/${company_idx}/patent/annualPay/annual_pay_final_comment`,
      payload
    );
  },

  annualPayUserComment(company_idx, payload) {
    return API.post(
      `/admin/company/${company_idx}/patent/annualPay/annual_pay_user_comment`,
      payload
    );
  },

  annualPayExcelUpload(company_idx, payload) {
    return API.post(
      `/admin/company/${company_idx}/patent/annualPay/annual_pay_excelUpload`,
      payload
    );
  },

  annualPayDeleteItem(company_idx, payload) {
    return API.post(
      `/admin/company/${company_idx}/patent/annualPay/annual_pay_delete`,
      payload
    );
  },

  getAllmailingFormIdx() {
    return API.get(`/manager/inventor/all_mailingFormIdx`);
  },

  getMailingFormIdxByIdx(payload) {
    return API.get(`/manager/inventor/mailingFormIdxByIdx`, {
      params: {
        idx: payload,
      },
    });
  },

  sendMailList(payload) {
    return API.get(`/manager/inventor/sendmailList`, {
      params: payload,
    });
  },

  annualPayUserDataComment(company_idx, payload) {
    return API.patch(
      `/admin/company/${company_idx}/patent/annualPay/annual_pay_right_comment`,
      payload
    );
  },

  updateAnnualPerCostData(payload) {
    if (payload?.ip_type === "T") {
      return API.post("/asset/patent/list_detail/updateData", payload);
    }
    if (payload?.ip_type === "D") {
      const companyIdx =
        payload.company_idx ||
        window.sessionStorage.getItem("company_idx");
      if (!companyIdx) {
        return Promise.reject(new Error("company_idx가 필요합니다."));
      }
      return API.post(
        `/admin/company/${companyIdx}/design/annualPay/updateData`,
        payload
      );
    }
    return API.post("/admin/company/patent/annualPay/updateData", payload);
  },

  /** 해외 건 등록상태 수동 업데이트 */
  updateAnnualPayOverseasRegisterStatus(company_idx, annual_pay_idx, payload) {
    return API.patch(
      `/admin/company/${company_idx}/patent/annualPay/${annual_pay_idx}/register-status`,
      payload
    );
  },

  /** 해외 건 납부현황(법적상태) 수동 업데이트 */
  updateAnnualPayOverseasLegalStatus(company_idx, annual_pay_idx, payload) {
    return API.patch(
      `/admin/company/${company_idx}/patent/annualPay/${annual_pay_idx}/legal-status`,
      payload
    );
  },

  /** @deprecated updateAnnualPayOverseasLegalStatus 사용 */
  updateAnnualPayOverseasStatus(company_idx, annual_pay_idx, payload) {
    return this.updateAnnualPayOverseasLegalStatus(
      company_idx,
      annual_pay_idx,
      payload
    );
  },

  /** 연차료 건별 설정 (관리주체 구분 MANAGEMENT_OWNER 등) */
  updateAnnualPaySetting(company_idx, annual_pay_idx, payload) {
    const ipPath =
      payload?.ip_type === "D" ? "design" : payload?.ip_type === "T" ? "trademark" : "patent";
    return API.put(
      `/admin/company/${company_idx}/${ipPath}/annualPay/${annual_pay_idx}/setting`,
      payload
    );
  },

  getAnnualPaySetting(company_idx, annual_pay_idx, params) {
    const ipPath =
      params?.ip_type === "D" ? "design" : params?.ip_type === "T" ? "trademark" : "patent";
    return API.get(
      `/admin/company/${company_idx}/${ipPath}/annualPay/${annual_pay_idx}/setting`,
      { params }
    );
  },

  // 포기권 복구 (일단 특허만)
  revertGiveUp(company_idx, annual_pay_idx) {
    return API.patch(
      `/admin/company/${company_idx}/patent/annualPay/${annual_pay_idx}/revertGiveUp`
    );
  },
  revertGiveUpAll(company_idx, annual_pay_idx) {
    return API.patch(
        `/admin/company/${company_idx}/patent/annualPay/${annual_pay_idx}/revertGiveUpAll`
    );
  },
  revertDelete(company_idx, annual_pay_idx) {
    return API.patch(
      `/admin/company/${company_idx}/patent/annualPay/${annual_pay_idx}/revertDelete`
    );
  },
  adminCheckPointList(payload) {
    return API.get("admin/help/checkpoint", {
      params: payload,
    });
  },
  adminCheckPointCategoriesList(payload) {
    return API.get("admin/help/checkpoint/category", {
      params: payload,
    });
  },
  addCheckPointList(payload) {
    return API.post("admin/help/checkpoint", payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  },
  editCheckPointList(payload) {
    return API.patch("admin/help/checkpoint", payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  },
  deleteCheckPointList(payload) {
    return API.delete("admin/help/checkpoint", {
      params: payload,
    });
  },
  getAdminPatentBankInfoData(annualFeeInfo) {
    let company_idx = annualFeeInfo.patent_idx;
    let annual_pay_idx = annualFeeInfo.annual_pay_idx;
    return API.get(
      `/admin/company/${company_idx}/patent/annualPay/${annual_pay_idx}/billing/bankInfo`,
      { skipGlobalLoading: true }
    );
  },
  getAdminPatentList(payload) {
    return API.get("/admin/ops/patent_fix/search", { params: payload });
  },
  postAdminAnnualPay(payload) {
    return API.post("/admin/ops/patent_fix/updateAnnualPay", payload);
  },
  updateNationAndAnnualPay(payload) {
    return API.post("/admin/ops/patent_fix/updateAnnualPayNation", payload);
  },
  updatePatentDates(payload) {
    return API.patch("/admin/ops/patent_fix/updatePatentDates", payload);
  },
  updateMainDate(payload) {
    return API.patch("/admin/ops/patent_fix/updateMainDate", payload);
  },
  updateBulkGiveUpAnnualPay(payload, config = {}) {
    return API.post("/admin/ops/patent_fix/bulkGiveUpAnnualPay", payload, config);
  },
  deleteAdminAsset(payload) {
    return API.post("/admin/ops/patent_fix/deleteAsset", payload);
  },
  matchAdminAssets(payload) {
    return API.post("/admin/ops/patent_fix/matchAssets", payload);
  },
  deleteAdminAssetBatch(payload) {
    return API.post("/admin/ops/patent_fix/deleteAssetBatch", payload);
  },
  restoreAdminAsset(payload) {
    return API.post("/admin/ops/patent_fix/restoreAsset", payload);
  },

  getAdminCompanySales(payload) {
    return API.get("/admin/ops/company/sales", { params: payload });
  },

  getAdminServiceSettingList(payload) {
    return API.get("/admin/ops/company", { params: payload });
  },

  getSiteCompanyInfo() {
    return API.get("/admin/ops/siteCompanyInfo");
  },

  createSiteCompanyInfo(payload) {
    return API.post("/admin/ops/siteCompanyInfo", payload);
  },

  updateSiteCompanyInfo(payload) {
    return API.patch("/admin/ops/siteCompanyInfo", payload);
  },

  getAdminServiceManagerList(payload) {
    return API.get("/admin/ops/company/managers", { params: payload });
  },

  updateAdminCompanySetting(company_idx, payload) {
    return API.patch(`/admin/ops/company/${company_idx}`, payload);
  },

  /** 기업 특허출원인코드(company_code) 변경 — 중복 시 409 */
  updateAdminCompanyApplicantCode(company_idx, payload) {
    return API.patch(
      `/admin/ops/company/${company_idx}/applicant-code`,
      payload
    );
  },

  getAdminCompanyPatentFee(payload) {
    return API.get("/admin/ops/company/patent/fee", { params: payload });
  },

  upsertAdminCompanyPatentFee(payload) {
    return API.put("/admin/ops/company/patent/fee", payload);
  },

  /** 개발 업데이트 이력 (dev/update_log) */
  getAdminDevUpdateLogList(payload) {
    return API.get("/admin/ops/dev/update_log", { params: payload });
  },

  createAdminDevUpdateLog(payload) {
    return API.post("/admin/ops/dev/update_log", payload);
  },

  updateAdminDevUpdateLog(idx, payload) {
    return API.patch(`/admin/ops/dev/update_log/${idx}`, payload);
  },

  /** 발신자 알림·메일 차단 (ops/member) */
  searchMembersByLoginId(payload) {
    return API.get("/admin/ops/member", { params: payload });
  },

  updateMemberDispatchBlock(memberIdx, payload) {
    return API.patch(`/admin/ops/member/${memberIdx}`, payload);
  },

  memberDispatchBlockTest(memberIdx, payload) {
    return API.post(`/admin/ops/member/${memberIdx}/dispatch-test`, payload);
  },

  /** 사용자 탭 컬럼 마스터 (ops/member_tab_master) */
  getMemberTabMasterTypes() {
    return API.get("/admin/ops/member_tab_master/types");
  },

  getMemberTabMasterList(params) {
    return API.get("/admin/ops/member_tab_master", { params });
  },

  createMemberTabMaster(payload) {
    return API.post("/admin/ops/member_tab_master", payload);
  },

  updateMemberTabMaster(idx, payload) {
    return API.patch(`/admin/ops/member_tab_master/${idx}`, payload);
  },

  activateMemberTabMaster(idx) {
    return API.patch(`/admin/ops/member_tab_master/${idx}/activate`);
  },

  deactivateMemberTabMaster(idx) {
    return API.patch(`/admin/ops/member_tab_master/${idx}/deactivate`);
  },

  /** KIPRIS 이력 수집 */
  startKiprisHistorySync(payload) {
    return API.post("/admin/kipris/history/sync", payload);
  },

  getKiprisHistoryJob(job_id) {
    return API.get(`/admin/kipris/history/job/${job_id}`);
  },

  getKiprisHistoryJobList(payload) {
    return API.get("/admin/kipris/history/job", { params: payload });
  },

  cancelKiprisHistoryJob(job_id) {
    return API.post(`/admin/kipris/history/job/${job_id}/cancel`);
  },

  /** KIPRIS ST.27 법적상태 코드 마스터 */
  getKiprisLegalStatusCodeTypes() {
    return API.get("/admin/kipris/legal_status_code/types");
  },

  getKiprisLegalStatusCodeList(payload) {
    return API.get("/admin/kipris/legal_status_code", { params: payload });
  },

  getKiprisLegalStatusCodeUnmapped(payload) {
    return API.get("/admin/kipris/legal_status_code/unmapped", { params: payload });
  },

  createKiprisLegalStatusCode(payload) {
    return API.post("/admin/kipris/legal_status_code", payload);
  },

  updateKiprisLegalStatusCode(idx, payload) {
    return API.patch(`/admin/kipris/legal_status_code/${idx}`, payload);
  },

  activateKiprisLegalStatusCode(idx) {
    return API.patch(`/admin/kipris/legal_status_code/${idx}/activate`);
  },

  deactivateKiprisLegalStatusCode(idx) {
    return API.patch(`/admin/kipris/legal_status_code/${idx}/deactivate`);
  },

  seedKiprisLegalStatusCodeDefaults() {
    return API.post("/admin/kipris/legal_status_code/seed");
  },

  importKiprisLegalStatusCodes(payload) {
    return API.post("/admin/kipris/legal_status_code/import", payload);
  },

  /** Admin NOW 등급 산출 */
  getNowGradeStatus(payload) {
    return API.get("/admin/ops/patent_fix/nowGrade/status", { params: payload });
  },

  startNowGradeCalc(payload) {
    return API.post("/admin/ops/patent_fix/nowGrade", payload);
  },

  getNowGradeJob(job_id) {
    return API.get(`/admin/ops/patent_fix/nowGrade/job/${job_id}`);
  },

  /** Admin 디자인/상표 최신화 (ipUpdateAll) */
  startDesignUpdateAll(payload) {
    // 409 conflict는 화면에서 title/message 처리 — 전역 alert·reject 중복 방지
    return API.post("/admin/ops/ipUpdateAll/design", payload, {
      skipGlobalErrorAlert: true,
      validateStatus: (status) =>
        (status >= 200 && status < 300) || status === 409,
    });
  },

  startTrademarkUpdateAll(payload) {
    return API.post("/admin/ops/ipUpdateAll/trademark", payload, {
      skipGlobalErrorAlert: true,
      validateStatus: (status) =>
        (status >= 200 && status < 300) || status === 409,
    });
  },

  getIpUpdateAllJob(job_id) {
    return API.get(`/admin/ops/ipUpdateAll/job/${job_id}`);
  },

  getDesignUpdateAllStatus(payload) {
    return API.get("/admin/ops/ipUpdateAll/design/status", { params: payload });
  },

  getTrademarkUpdateAllStatus(payload) {
    return API.get("/admin/ops/ipUpdateAll/trademark/status", {
      params: payload,
    });
  },

  /** 기업 멤버 목록 (IP 담당자 선택용) */
  getAdminCompanyMembers(company_idx, params = {}) {
    return API.get(`/admin/company/${company_idx}/member`, { params });
  },

  /** IP 담당자 일괄 교체 미리보기 */
  previewIpManagerReplace(payload) {
    return API.post("/admin/ops/ipManagerReplace/preview", payload);
  },

  /** IP 담당자 일괄 교체 실행 (type: P|T|D|ALL) */
  replaceIpManager(payload) {
    return API.post("/admin/ops/ipManagerReplace", payload);
  },

  /** 최종 권리자 업데이트 (LAST_RG_HOLDER) */
  startBulkRightHolder(formData) {
    return API.post("/admin/ops/bulkRightHolder", formData, {
      skipGlobalErrorAlert: true,
      validateStatus: (status) =>
        (status >= 200 && status < 300) || status === 409,
    });
  },

  getBulkRightHolderJob(job_id) {
    return API.get(`/admin/ops/bulkRightHolder/job/${job_id}`, {
      skipGlobalErrorAlert: true,
    });
  },

  getBulkRightHolderStatus() {
    return API.get("/admin/ops/bulkRightHolder/status");
  },

  getBulkRightHolderLogs(params = {}) {
    return API.get("/admin/ops/bulkRightHolder/logs", { params });
  },

  /** 기업별 user_action_log */
  getUserActionLogs(params = {}) {
    return API.get("/admin/ops/userActionLog", { params });
  },

  getUserActionLogMeta() {
    return API.get("/admin/ops/userActionLog/meta");
  },
};
